import React from 'react';
import {Input} from '@practicegenius/pg-ui/src/base/Material/components/Input';
import {UsernameSuggester} from '../UsernameSuggester';

type InputProps = React.ComponentProps<typeof Input>;
type OptionalInputProps = Omit<InputProps, 'name' | 'value' | 'onChange'>;

type Props = {
  name: string;
  value: InputProps['value'];
  onChange: InputProps['onChange'];
  error: InputProps['error'];
  autoFocus?: boolean;
  inputProps?: OptionalInputProps;
  suggesterProps?: Omit<
    React.ComponentProps<typeof UsernameSuggester>,
    'onSuggestionSelect'
  >;
};

export function UsernameSelector({
  name,
  value,
  onChange,
  error,
  inputProps,
  suggesterProps,
  autoFocus,
}: Props) {
  const inputRef: React.Ref<HTMLInputElement> = React.useRef(null);

  return (
    <>
      <Input
        name={name}
        innerRef={inputRef}
        label="Username"
        {...inputProps}
        {...{autoFocus, value, onChange, error}}
      />
      <UsernameSuggester
        {...suggesterProps}
        onSuggestionSelect={(value: string) => {
          // @ts-ignore - This is a code smell... 🐽, this API's onChange expects to receive an event, but we don't have an event here to pass along.
          onChange({target: {value}});
          inputRef.current && inputRef.current.focus();
        }}
      />
    </>
  );
}
